package app.nestbridge.feature.designcatalog.ui

import app.nestbridge.feature.designcatalog.screen.DesignCatalogScreen
import app.nestbridge.feature.designcatalog.screen.DesignCatalogState
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.screen.Screen
import com.slack.circuit.runtime.ui.Ui
import com.slack.circuit.runtime.ui.ui
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
public class DesignCatalogUiFactory : Ui.Factory {
  override fun create(screen: Screen, context: CircuitContext): Ui<*>? = when (screen) {
    DesignCatalogScreen -> ui<DesignCatalogState> { state, modifier -> DesignCatalogUi(state = state, modifier = modifier) }
    else -> null
  }
}
